import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ExportsCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 298px;
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};
  ${getShadow('raisedLight')};
`
